import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { APIStatus } from 'types';
import { LoadingSpinner } from 'components/LoadingSpinner';
import axios from 'axios';
import AddVirtualKeyBanner from '../Cars/AddVirtualKeyBanner';

const ConnectCars = () => {
  const location = useLocation();
  const [showVirtualKeyModal, setShowVirtualKeyModal] = useState(false);
  const [connectCarsStatus, setCarsConnectStatus] = useState<APIStatus>({
    loading: false,
    success: false,
    error: null,
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const token = queryParams.get('token');
    const ownerId = queryParams.get('ownerId');

    if (!token && !code) return;

    if (code && token) {
      setCarsConnectStatus({ loading: true, success: false, error: null });

      const api = `${process.env.REACT_APP_API_ENDPOINT}/api/v1`;

      const request = axios.create({
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      request
        .post(`${api}/admins/cars/standard-fleet/connect`)
        .then(res => res.data)
        .then(() => {
          setCarsConnectStatus({ loading: false, success: true, error: null });

          setShowVirtualKeyModal(true);
        })
        .catch(error => {
          setCarsConnectStatus({ loading: false, success: false, error });
        });

      return;
    }

    const redirectUri = encodeURIComponent(`${process.env.REACT_APP_STANDARD_FLEET_OWNER_REDIRECT_URI}&token=${token}`);

    window.open(
      `${process.env.REACT_APP_STANDARD_FLEET_URI}&redirect_uri=${redirectUri}&partner_ref=${ownerId}`,
      '_blank'
    );
  }, []);

  return (
    <div>
      <AddVirtualKeyBanner
        style={{ marginBottom: '12px' }}
        visible={showVirtualKeyModal}
        showBanner={false}
      />

      {
        connectCarsStatus.loading && (
          <LoadingSpinner />
        )
      }

      {
        connectCarsStatus.success && (
          <div>Connected successfully!</div>
        )
      }

      {
        connectCarsStatus.error && (
          <div>
            Please refresh the link the owner shared with you and try again.
          </div>
        )
      }
    </div>
  );
};

export default ConnectCars;
